<template>
  <div class="board-controls" v-if="!isPresentationMode">
    <BoardSizeControl
      v-if="showBoardSize"
      @size-changed="$emit('size-changed', $event)"
    />

    <button-tooltip
      v-if="showFlip"
      tooltip="Flip board orientation (O)"
      label="Flip"
      size="is-small"
      type="is-light"
      icon-left="retweet"
      @click="$emit('flip')"
    />

    <CopyToClipboard
      v-if="showFenCopy"
      :value="fenValue"
      success-message="FEN copied to clipboard!"
      label="FEN"
      :tooltip="`Copy FEN: ${fenValue}` | wrappableFen"
    />

    <CopyToClipboard
      v-if="showPgnCopy"
      :value="pgnValue"
      success-message="PGN copied to clipboard!"
      label="PGN"
      :tooltip="`Copy PGN: ${pgnValue}` | wrappableFen"
    />

    <button-tooltip
      v-if="showClear"
      tooltip="Clear the board"
      label="Clear"
      size="is-small"
      type="is-light"
      icon-left="trash-alt"
      @click="$emit('clear')"
    />

    <button-tooltip
      v-if="showReset"
      tooltip="Reset to initial position"
      label="Reset"
      size="is-small"
      type="is-light"
      icon-left="chess-board"
      @click="$emit('reset')"
    />

    <button-tooltip
      v-if="showSave"
      tooltip="Save current position"
      label="Save"
      size="is-small"
      type="is-warning is-light"
      icon-left="save"
      outlined
      @click="$emit('save')"
    />

    <button-tooltip
      v-if="showScenario"
      tooltip="Create example from current position"
      label="Example"
      size="is-small"
      type="is-light is-info"
      icon-left="play"
      outlined
      @click="$emit('scenario')"
    />

    <button-tooltip
      v-if="showFreeMode"
      tooltip="Switch to free mode"
      label="Free Mode"
      size="is-small"
      type="is-light is-info"
      icon-left="chess-board"
      outlined
      @click="$emit('free-mode')"
    />

    <button-tooltip
      v-if="showExit"
      tooltip="Exit current mode"
      label="Exit"
      size="is-small"
      type="is-light is-danger"
      icon-left="arrow-left"
      outlined
      @click="$emit('exit')"
    />
  </div>
</template>

<script>
import BoardSizeControl from "./BoardSizeControl.vue";
import CopyToClipboard from "@/components/common/CopyToClipboard.vue";
import ButtonTooltip from "@/components/ui/ButtonTooltip.vue";

export default {
  name: "BoardControls",

  components: {
    BoardSizeControl,
    CopyToClipboard,
    ButtonTooltip,
  },

  props: {
    showBoardSize: { type: Boolean, default: true },
    showFlip: { type: Boolean, default: true },
    showFenCopy: { type: Boolean, default: false },
    showPgnCopy: { type: Boolean, default: false },
    showClear: { type: Boolean, default: false },
    showReset: { type: Boolean, default: false },
    showSave: { type: Boolean, default: false },
    showScenario: { type: Boolean, default: false },
    showFreeMode: { type: Boolean, default: false },
    showExit: { type: Boolean, default: false },
    isPresentationMode: { type: Boolean, default: false },

    fenValue: { type: String, default: "" },
    pgnValue: { type: String, default: "" },
  },

  emits: [
    "size-changed",
    "flip",
    "clear",
    "reset",
    "save",
    "scenario",
    "free-mode",
    "exit",
  ],

  mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },

  methods: {
    handleKeyDown(event) {
      // Don't trigger if user is typing in an input field
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA"
      ) {
        return;
      }

      if (event.key.toLowerCase() === "o" && this.showFlip) {
        event.preventDefault();
        this.$emit("flip");
      }
    },
  },
};
</script>
